import * as React from "react";

function IconLetterJ({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-letter-j" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/letter-j"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4" /></svg>;
}

export default IconLetterJ;